<template>
  <Row class="py-6 pl-2">
    <Icon
      dense
      icon="$symbols-circle-info-outline"
      color="primary"
    />
    <Link
      blank
      class="text-paragraph-2 ml-1"
      color="primary"
      href="https://www.locaweb.com.br/ajuda/wiki/atualizar-icone-do-site-criador-de-sites/"
      v-text="lc.help"
    />
  </Row>
</template>

<script>
import { Icon, Link, Row, useLocale } from '@locaweb/design-system-vue'

export default {
  name: 'StepByStep',
  components: {
    Row,
    Link,
    Icon
  },
  setup () {
    const lc = useLocale('site.favicon.faviconCard.stepByStep')

    return { lc }
  }
}
</script>
